import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Fetch all tenants from tenantmaster collection
 */
export const fetchTenantsFromDB = async () => {
  try {
    const tenantsSnapshot = await getDocs(collection(db, "tenantmaster"));
    return tenantsSnapshot.docs.map(doc => ({
      id: doc.id,
      tenantId: doc.data().tenantId,
      tenantName: doc.data().tenantName,
      ...doc.data()
    }));
  } catch (error) {
    console.error("Error fetching tenants:", error);
    throw error;
  }
};
